import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const CANDIDATES_ITEMS_PER_PAGE = 10;

export const useGetCandidates = (/* limit: number, page: number, filter: string */) => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getCandidates = (
    query: string,
    page: number = 1,
    limit: number = CANDIDATES_ITEMS_PER_PAGE
  ) => {
    const reqUrl = query
      ? `/api/v1/profile/search?limit=${limit}&page=${page}&${query}`
      : `/api/v1/profile/search?limit=${limit}&page=${page}`;
    send({}, reqUrl).then();
  };

  return {
    getCandidates,
    data,
    isLoading,
    error,
  };
};
